import { useQuery } from "@tanstack/react-query";
import { createEmbedToken } from "../services/embed/embedApi";

// The preview token lives 10 minutes; a fresh one comes a minute before it ends.
const PREVIEW_REFRESH_MS = 9 * 60 * 1000;

/**
 * Mints an owner-only preview token (signed in with the app session) for the live preview, so the
 * preview shows real data whatever the share access is, and never changes that access.
 */
export const useEmbedPreviewToken = (storyId: string, enabled: boolean) =>
  useQuery({
    queryKey: ["embedPreviewToken", storyId],
    queryFn: async () => (await createEmbedToken(storyId, undefined, true)).token,
    enabled: enabled && Boolean(storyId),
    staleTime: PREVIEW_REFRESH_MS,
    refetchInterval: PREVIEW_REFRESH_MS,
    gcTime: 0,
    retry: false,
  });
